import { PartnerNetwork } from "@commons-monorepo/index";

export const getPartnerSocials = (partnerNetwork: PartnerNetwork) => {
  const socials = [];
  if (!!partnerNetwork?.facebook)
    socials.push({
      source: "Facebook",
      iconName: "icon-e-facebook",
      url: `https://www.facebook.com/${partnerNetwork.facebook}`,
    });
  if (!!partnerNetwork?.twitter)
    socials.push({
      source: "Twitter",
      iconName: "icon-e-twitter",
      url: `https://twitter.com/${partnerNetwork.twitter}`,
    });
  if (!!partnerNetwork?.instagram)
    socials.push({
      source: "Instagram",
      iconName: "icon-e-instagram",
      url: `https://www.instagram.com/${partnerNetwork.instagram}`,
    });
  if (!!partnerNetwork?.tiktok)
    socials.push({
      source: "Tiktok",
      iconName: "icon-e-tik-tok",
      url: `https://www.tiktok.com/${partnerNetwork.tiktok}`,
    });
  return socials;
};
